import React, { useState, useEffect } from "react";
import { getFilteredDocuments } from "../data/common";
import InnerCompnents from "../components/innercomponents/innercomponents";

function FittingComponents() {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      getFilteredDocuments("products", "category", "==", "Fitting Products")
        .then((res) => { 
          console.log("Fitting Components Data:", res);
          setData(res);
         })
        .catch((err) => { console.log(err); });
    };

    fetchData();
  }, []);

  return (
    <>
      <div className="container-fluid mt-3">
        <InnerCompnents  componentsData={data}></InnerCompnents>
      </div>
    </>
  );
}

export default FittingComponents;
